import styled from "styled-components";
import {
  BASIC_BROWN,
  BASIC_DARK_GRAY,
  BASIC_WHITE,
} from "../../../constants/colors";

type Props = {
  id?: number;
  selected: boolean;
  categoryName: string;
  onClick: () => void;
};

export const MenuCategoryItem: React.FC<Props> = ({
  id,
  selected,
  categoryName,
  onClick,
}) => {
  return (
    <MenuCategoryItemContainer
      $selected={selected}
      onClick={onClick}
      id={`category-${id}`}
    >
      <MenuCategoryItemText $selected={selected} id={`category-text-${id}`}>
        {categoryName}
      </MenuCategoryItemText>
    </MenuCategoryItemContainer>
  );
};
const MenuCategoryItemContainer = styled.div<{ $selected: boolean }>`
  padding: 11px 14px;
  margin: 20px 0px;
  display: inline-block;
  border-radius: 100px;
  color: ${BASIC_DARK_GRAY};
  cursor: pointer;
  &:nth-of-type(1) {
    margin-left: 18px;
  }
  background-color: ${({ $selected }) =>
    $selected ? BASIC_BROWN : "transparent"};
`;
const MenuCategoryItemText = styled.div<{ $selected: boolean }>`
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  color: ${({ $selected }) => ($selected ? BASIC_WHITE : BASIC_DARK_GRAY)};
`;
